import { Elements } from '@mul-pay/mptoken-react-js';
import { TokenResponse } from '@mul-pay/mptoken-js';
import { MulpayElementForm } from '../MulpayElementForm';

import { useMulpay } from 'src/components/gmo-pg/MulpayProvider';
import { useGetMulpayOrderEnabledOptIn } from 'src/hooks/api/reservation-flow/useGetMulpayOrderEnabledOptIn';

export const MulpayFormWrapper = ({
  onChange,
  merchantPublicId,
}: {
  onChange: (tokenResponse?: TokenResponse) => void;
  merchantPublicId: string;
}) => {
  const multiPayment = useMulpay();
  const optIns = useGetMulpayOrderEnabledOptIn(merchantPublicId);

  return (
    <Elements multiPayment={multiPayment}>
      {optIns && (
        <MulpayElementForm
          onChange={onChange}
          isVmAvailable={optIns.vm_brand_available}
          isJaddAvailable={optIns.jadd_brand_available}
        />
      )}
    </Elements>
  );
};
